import React, { useState, useEffect, useCallback, useMemo } from 'react';
import UserMediaService from '../../../services/UserMediaService';
import './Settings.css';
import MediaSettings from '../MediaSettings/MediaSettings';
import Checkbox from '../primitives/Checkbox/Checkbox';
import { SETTINGS_STORAGE_KEY } from '../../../utils/constants';
import HeaderWithBack from '../primitives/HeaderWithBack/HeaderWithBack';

const Settings = () => {
  const [slowSystem, setSlowSystem] = useState(false);
  const [showSelfView, setShowSelfView] = useState(true);
  const [debug, setDebug] = useState(true);

  useEffect(() => {
    const storageItem = localStorage.getItem(SETTINGS_STORAGE_KEY);
    if (!storageItem) return;
    const storedSettings = JSON.parse(storageItem);
    if (storedSettings) {
      if (storedSettings.slowSystem) setSlowSystem(storedSettings.slowSystem);
      if (storedSettings.showSelfView) setShowSelfView(storedSettings.showSelfView);
      if (storedSettings.debug) setDebug(storedSettings.debug);
    }

    return () => {
      // saveSettings(); // Is this better than saving every time a setting is changed?
      UserMediaService.stopMediaTracks();
    }
  }, []);

  useEffect(() => {
    saveSettings();
  }, [slowSystem, showSelfView, debug]);

  const saveSettings = useCallback(() => {
    const settings = { slowSystem, showSelfView, debug };
    localStorage.setItem(SETTINGS_STORAGE_KEY, JSON.stringify(settings));
  }, [slowSystem, showSelfView, debug]);

  const handleShouldEnableMic = useCallback((isEnabled: boolean) => {
    if (!isEnabled) UserMediaService.stopAudioTrack();
  }, []);

  const handleShouldEnableCamera = useCallback((isEnabled: boolean) => {
    if (!isEnabled) UserMediaService.stopVideoTrack();
  }, []);

  const headerWithBackElement = useMemo(() => (
    <HeaderWithBack title={'Settings'} />
  ), [])


  return (
    <div className='root-settings'>
      { headerWithBackElement }
      <MediaSettings onShouldEnableMic={handleShouldEnableMic} onShouldEnableCamera={handleShouldEnableCamera} />
      <div className='container'>
        <Checkbox isChecked={showSelfView} onChange={(isChecked) => setShowSelfView(isChecked)} label='Self Cam' />
        <Checkbox isChecked={slowSystem} onChange={(isChecked) => setSlowSystem(isChecked)} label='Lower Quality' />
        <Checkbox isChecked={debug} onChange={(isChecked) => setDebug(isChecked)} label='Debug' />
      </div>
    </div>
  );
};

export default Settings;
